import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabaseClient';

export default function VersePopup() {
  const [popup, setPopup]         = useState(null);
  const [visible, setVisible]     = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [lang, setLang]           = useState('en');

  useEffect(() => {
    supabase.from('verse_popup').select('*').then(({ data, error }) => {
      if (error || !data || data.length === 0) return;
      const active = data.find(r => r.active === true || r.active === 'true');
      if (!active || !active.image_url) return;

      // Dismiss check — based on popup ID, not date
      // This way a NEW popup always shows even if today's was dismissed
      const dismissedId = localStorage.getItem('zion_verse_popup_dismissed_id');
      if (dismissedId === String(active.id)) return;

      setPopup(active);
      setTimeout(() => setVisible(true), 1000);
    });
  }, []);

  const dismiss = () => {
    setDismissed(true);
    // Save this specific popup's ID — next NEW popup will still show
    localStorage.setItem('zion_verse_popup_dismissed_id', String(popup.id));
    // Also clear old date-based key if exists
    localStorage.removeItem('zion_verse_popup_dismissed');
  };

  if (!visible || dismissed || !popup) return null;

  const hasTamil   = Boolean(popup.image_url_tamil);
  const activeImg  = lang === 'ta' && hasTamil ? popup.image_url_tamil : popup.image_url;
  const activeText = lang === 'ta' && popup.verse_text_tamil ? popup.verse_text_tamil : popup.verse_text;
  const activeRef  = lang === 'ta' && popup.verse_ref_tamil  ? popup.verse_ref_tamil  : popup.verse_ref;

  return (
    <div style={{
      position:'fixed', inset:0, zIndex:9997,
      background:'rgba(0,0,0,0.82)',
      display:'flex', alignItems:'center', justifyContent:'center',
      padding:20, backdropFilter:'blur(6px)',
    }}>
      <div style={{
        maxWidth:440, width:'100%',
        background:'linear-gradient(160deg,rgba(13,27,62,0.99),rgba(7,15,34,0.99))',
        border:'1px solid rgba(201,168,76,0.4)',
        borderRadius:20, overflow:'hidden',
        boxShadow:'0 24px 80px rgba(0,0,0,0.8)',
        position:'relative',
      }}>
        <button onClick={dismiss} style={{
          position:'absolute', top:14, right:14, zIndex:10,
          background:'rgba(255,255,255,0.1)', border:'none',
          color:'#c8bfa8', width:32, height:32, borderRadius:'50%',
          fontSize:'1rem', cursor:'pointer',
          display:'flex', alignItems:'center', justifyContent:'center',
        }}>✕</button>

        <div style={{ padding:'18px 24px 10px', textAlign:'center' }}>
          <div style={{ fontSize:'0.62rem', letterSpacing:'0.3em', color:'rgba(201,168,76,0.6)', textTransform:'uppercase', marginBottom: hasTamil ? 10 : 0 }}>
            ✦ Today's Word ✦
          </div>
          {hasTamil && (
            <div style={{ display:'flex', gap:8, justifyContent:'center' }}>
              {[['en','🇬🇧 English'],['ta','🕊️ Tamil']].map(([k,lb]) => (
                <button key={k} onClick={() => setLang(k)} style={{
                  background: lang===k ? '#c9a84c' : 'rgba(255,255,255,0.08)',
                  border: lang===k ? 'none' : '1px solid rgba(201,168,76,0.3)',
                  color: lang===k ? '#070f22' : '#c8bfa8',
                  fontSize:'0.72rem', fontWeight:700, padding:'5px 16px',
                  borderRadius:20, cursor:'pointer',
                }}>{lb}</button>
              ))}
            </div>
          )}
        </div>

        <div style={{ padding:'0 18px' }}>
          <img src={activeImg} alt="Daily Verse"
            style={{ width:'100%', borderRadius:12, border:'1px solid rgba(201,168,76,0.25)', display:'block' }}
          />
        </div>

        {(activeText || activeRef) && (
          <div style={{ padding:'14px 24px', textAlign:'center' }}>
            {activeText && <p style={{ fontFamily:"'Crimson Pro',serif", fontStyle:'italic', fontSize:'1rem', color:'#e8c97a', lineHeight:1.7, marginBottom:6 }}>"{activeText}"</p>}
            {activeRef  && <div style={{ fontSize:'0.78rem', color:'rgba(201,168,76,0.7)', letterSpacing:'0.1em' }}>— {activeRef}</div>}
          </div>
        )}

        <div style={{ padding:'0 24px 20px', textAlign:'center' }}>
          <button onClick={dismiss} style={{
            background:'linear-gradient(135deg,#c9a84c,#8b6914)',
            border:'none', color:'#070f22',
            fontFamily:"'Raleway',sans-serif", fontWeight:700,
            fontSize:'0.82rem', letterSpacing:'0.12em', textTransform:'uppercase',
            padding:'12px 36px', borderRadius:40, cursor:'pointer',
          }}>God Bless You 🙏</button>
          <div style={{ fontSize:'0.62rem', color:'rgba(200,191,168,0.3)', marginTop:10 }}>
            Zion Assemblies of God Church, Ooty
          </div>
        </div>
      </div>
    </div>
  );
}
